'use strict';

angular.module('theme').component('orderProductSummary', {
	templateUrl: 'component/order-product-summary.html',
	bindings: {
		productId: '@',
		productTagLine: '@',
		productTitle: '@',
	},
	controller: function ($scope, $window, $location, $cookies, CartService, ArticleService, ProductService, TrackerService, ProductTrackerService) {
		var self = this;

		self.special = self.productId === 'Special';

		if ($cookies.get('campaign-code-discount')) {
			var discount = JSON.parse($cookies.get('campaign-code-discount'));
			self.sendDiscountCode = discount.code;

			if (!discount || discount.code === '') return;

			if (discount.type === 'Percent') {
				self.percentDiscount = Math.abs(discount.value) / 100;
			} else if(discount.amount) {
				var value = Math.abs(discount.amount);

				if (value == 0) return;

				self.discount = value;
			}
		}

		ArticleService.getProduct(self.productId).then(function (product) {
			self.product = product;
			self.prices = product.prices;

			self.selected = _.find(self.prices, function(price) {
				if (self.special) return price.number === 1;
				return price.number === 4;
			});

			ProductTrackerService.updateProduct(self.product, self.selected, self.getServings());
		});

		this.setSelected = function (price) {
			self.selected = price;

			ProductTrackerService.productChange(self.product.type, price);
		};

		this.select = function () {
			CartService.add(self.product, this.selected.number).then(function () {

				// get wordpress product
				ProductService.get(self.product.type).then(function (product) {
					var data = {
						'currency': 'SEK',
						'add': {
							'actionField': {'list': window.location.pathname},
							'products': [{
								'name': product.title,
								'id': self.product.type,
								'price': self.selected.amount,
								'quantity': 1,
								'dimension3': self.getServings(),
								'dimension4': self.selected.number
							}]
						}
					};

					//TrackerService.ecommerceEvent('addToCart', data);
				});

				TrackerService.addToCart(self.product, self.selected.amount);

				// redirect to cart
				$window.location.href = 'https://minasidor.matkomfort.se/order?kasse='+self.product.longname+'&personer=4'+'&dc='+self.sendDiscountCode;
			});
		};

		this.getServings = function () {
			switch(self.productId) {
			case 'VEGO':
			case 'STHLM':
				return 3;
			default:
				return 4;
			}
		};
	}
});
